import { useEffect, useState } from "react"
import { Event, track } from "../analytics"

const identifyTheme = theme => {
  try {
    if (!window.amplitude?.Identify || !window.amplitude?.getInstance) return
    const identify = new window.amplitude.Identify().append(
      "currentTheme",
      theme
    )
    window.amplitude.getInstance().identify(identify)
  } catch (_) {
    // Analytics must never prevent a theme change.
  }
}

export const useThemeSwitcher = () => {
  const [theme, setTheme] = useState("light")
  const toggleTheme = () => {
    const nextTheme = theme === "light" ? "dark" : "light"
    setTheme(nextTheme)
    try {
      window.localStorage.setItem("theme", nextTheme)
    } catch (_) {
      // The theme still works when storage is unavailable.
    }
    track(Event.theme_toggled, { theme: nextTheme })
    identifyTheme(nextTheme)
  }
  useEffect(() => {
    let localTheme
    try {
      localTheme = window.localStorage.getItem("theme")
    } catch (_) {}
    const initialTheme = localTheme === "dark" ? "dark" : "light"
    setTheme(initialTheme)
    identifyTheme(initialTheme)
  }, [])
  return [theme, toggleTheme]
}
